import DeferredImage from "../deferred-image/deferred-image";
import { useMemo } from "react";

import "./clients-section.css";
import AppTitle from "../app-title/app-title";

// Main clients
import main_1 from "./static/main/main_1-1.webp";
import main_2 from "./static/main/main_1-2.webp";
import main_3 from "./static/main/main_2-1.webp";
import main_4 from "./static/main/main_2-2.webp";
import main_5 from "./static/main/main_3-1.webp";
import main_6 from "./static/main/main_3-2.webp";
import main_7 from "./static/main/main_4-1.webp";
import main_8 from "./static/main/main_4-2.webp";
import main_9 from "./static/main/main_5-1.webp";
import main_10 from "./static/main/main_5-2.webp";
import main_11 from "./static/main/main_6-1.webp";
import main_12 from "./static/main/main_6-2.webp";
import main_13 from "./static/main/main_7-1.webp";
import main_14 from "./static/main/main_7-2.webp";
import main_15 from "./static/main/main_8-1.webp";
import main_16 from "./static/main/main_8-2.webp";

// Passenger cars clients
import passenger_cars_1 from "./static/passenger_cars/passenger_cars_1-1.webp";
import passenger_cars_2 from "./static/passenger_cars/passenger_cars_1-2.webp";
import passenger_cars_3 from "./static/passenger_cars/passenger_cars_2-1.webp";
import passenger_cars_4 from "./static/passenger_cars/passenger_cars_2-2.webp";
import passenger_cars_5 from "./static/passenger_cars/passenger_cars_3-1.webp";
import passenger_cars_6 from "./static/passenger_cars/passenger_cars_3-2.webp";
import passenger_cars_7 from "./static/passenger_cars/passenger_cars_4-1.webp";
import passenger_cars_8 from "./static/passenger_cars/passenger_cars_4-2.webp";
import passenger_cars_9 from "./static/passenger_cars/passenger_cars_5-1.webp";
import passenger_cars_10 from "./static/passenger_cars/passenger_cars_5-2.webp";
import passenger_cars_11 from "./static/passenger_cars/passenger_cars_6-1.webp";
import passenger_cars_12 from "./static/passenger_cars/passenger_cars_6-2.webp";
import passenger_cars_13 from "./static/passenger_cars/passenger_cars_7-1.webp";
import passenger_cars_14 from "./static/passenger_cars/passenger_cars_7-2.webp";

// Trucks clients
import client_01 from "./static/trucks/trucks_1-1.webp";
import client_02 from "./static/trucks/trucks_1-2.webp";
import client_03 from "./static/trucks/trucks_2-1.webp";
import client_04 from "./static/trucks/trucks_2-2.webp";
import client_05 from "./static/trucks/trucks_3-1.webp";
import client_06 from "./static/trucks/trucks_3-2.webp";
import client_07 from "./static/trucks/trucks_4-1.webp";
import client_08 from "./static/trucks/trucks_4-2.webp";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const CLIENT_SETS = {
  main: [
    { src: main_1, name: "Клиент №1" },
    { src: main_2, name: "Клиент №2" },
    { src: main_3, name: "Клиент №3" },
    { src: main_4, name: "Клиент №4" },
    { src: main_5, name: "Клиент №5" },
    { src: main_6, name: "Клиент №6" },
    { src: main_7, name: "Клиент №7" },
    { src: main_8, name: "Клиент №8" },
    { src: main_9, name: "Клиент №9" },
    { src: main_10, name: "Клиент №10" },
    { src: main_11, name: "Клиент №11" },
    { src: main_12, name: "Клиент №12" },
    { src: main_13, name: "Клиент №13" },
    { src: main_14, name: "Клиент №14" },
    { src: main_15, name: "Клиент №15" },
    { src: main_16, name: "Клиент №16" },
  ],
  passenger_cars: [
    { src: passenger_cars_1, name: "Клиент №1" },
    { src: passenger_cars_2, name: "Клиент №2" },
    { src: passenger_cars_3, name: "Клиент №3" },
    { src: passenger_cars_4, name: "Клиент №4" },
    { src: passenger_cars_5, name: "Клиент №5" },
    { src: passenger_cars_6, name: "Клиент №6" },
    { src: passenger_cars_7, name: "Клиент №7" },
    { src: passenger_cars_8, name: "Клиент №8" },
    { src: passenger_cars_9, name: "Клиент №9" },
    { src: passenger_cars_10, name: "Клиент №10" },
    { src: passenger_cars_11, name: "Клиент №11" },
    { src: passenger_cars_12, name: "Клиент №12" },
    { src: passenger_cars_13, name: "Клиент №13" },
    { src: passenger_cars_14, name: "Клиент №14" },
  ],
  trucks: [
    { src: client_01, name: "Клиент №1" },
    { src: client_02, name: "Клиент №2" },
    { src: client_03, name: "Клиент №3" },
    { src: client_04, name: "Клиент №4" },
    { src: client_05, name: "Клиент №5" },
    { src: client_06, name: "Клиент №6" },
    { src: client_07, name: "Клиент №7" },
    { src: client_08, name: "Клиент №8" },
  ],
};

function ClientsSection({ type = "main", titleClassName = "" }) {
  const clients = useMemo(() => CLIENT_SETS[type] || CLIENT_SETS.main, [type]);
  const isMobileXl = useMediaQuery("xl");

  const getDesktopClassName = () => {
    return "clients--desktop";
  };

  return (
    <>
      <AppTitle text={"Клиенты"} className={titleClassName} />
      <div
        className={
          isMobileXl ? "horizontal-gallery clients" : getDesktopClassName()
        }
      >
        <div className="clients-scroll-container">
          {clients.map((item) => (
            <div className="client-image" key={item.src}>
              <DeferredImage
                width={470}
                height={470}
                src={item.src}
                alt={item.name}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default ClientsSection;
